import React, { useContext } from 'react'
import moment from 'moment'
import { track as fdTrack } from 'fd-package'
import { FirstNormalTip } from 'meinian-package/src/component/firstTooltip'
import Bubble from 'meinian-package/src/baseComponent/bubble'
import Tooltip from 'meinian-package/src/baseComponent/tooltip'
import Button from 'meinian-package/src/baseComponent/button'
import { formatNumber100Add } from 'meinian-package/src/utils/number'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import Icon from 'meinian-package/src/component/icon'
import versionNumber from 'meinian-package/src/component/useFunModal/versionNumber'
import useVersionNumber from 'meinian-package/src/common/hooks/useVersionNumber'
import util from 'meinian-package/src/utils/util'
import request from 'meinian-package/src/utils/request'
import { getDtoConfig } from 'meinian-package/src/component/platformConfig'
import useRepeatCollectModalApiWrap from 'component/useFunModal/repeatCollectModal'
import getFilename from 'component/imageDetail/getFilename'
import { getUserInfo } from 'meinian-package/src/common/userInfo'
import classNames from 'classnames'
import isIPad from 'meinian-package/src/common/isIPad'
import { FdAiDrawerContext } from 'context'
import { IMAGE_DETAIL_TAB } from '../../infoView'
import styles from './index.module.less'

const MAX_SCALE = 2
const MIN_SCALE = 0.15
const RATIO = 1.25

export default ({
  currentImage,
  imgInfoList = [],
  isSampleDetail = false,
  sampleData,
  scale,
  setScale,
  tabValue,
  showBox,
  onShowBox,
  showNoteLabel,
  onShowNoteLabel,
  setIsAnnotate,
  isAnnotate
}) => {
  const userInfo = getUserInfo()
  const { platformId, sourceTime, imageGroupEntityId, collectId, mainUrl, duplicateBlogNum, isFromZkPlatform } = currentImage || {}
  const dtoConfig = getDtoConfig(platformId, isFromZkPlatform)
  const currentDto = platformId ? currentImage?.[dtoConfig?.dto] : {}
  const fdAiDrawerRef = useContext(FdAiDrawerContext)
  const { isAuthLimit } = useVersionNumber()

  const download = () => {
    if (!isSampleDetail) {
      request.downloadFromAsync('/zhikuan/mn/export/download-blog-image', {
        type: 1,
        imageUrl: currentImage.mainUrl,
        fileName: getFilename(platformId, currentDto, sourceTime)
      })
      util.track('mn-image-download', {
        module1: '单款下载',
        module2: '当前图片'
      })
    } else {
      const name = `样衣_${sampleData.id}_${moment(sampleData.createdAt).format('YYYYMMDD')}.jpg`
      request.downloadFromAsync('/zhikuan/mn/export/download-blog-image', {
        type: 2,
        imageUrl: currentImage.mainUrl,
        fileName: name
      })
    }
  }

  const downloadAll = () => {
    if (!isAuthLimit('meinian_download_blog_limit')) {
      versionNumber({
        title: '款式下载'
      })
      return
    }
    if (!isSampleDetail) {
      request.downloadFromAsync('/zhikuan/mn/export/download-blog-image', {
        type: 1,
        collectOrSampleId: collectId,
        fileName: imageGroupEntityId
      }, '.zip')
      util.track('mn-image-download', {
        module1: '单款下载',
        module2: '全部图片'
      })
    } else {
      request.downloadFromAsync('/zhikuan/mn/export/download-blog-image', {
        type: 2,
        collectOrSampleId: sampleData.id,
        fileName: `样衣_${sampleData.id}_${moment(sampleData.createdAt).format('YYYYMMDD')}`,
      }, '.zip')
    }
  }
  return <div
    className={styles.otherOperation}
    style={{
      right: isIPad ? '48px' : '40px'
    }}
  >
    <div className="meinian-image-detail-actions" onClick={e => e.stopPropagation()}>
      <FirstNormalTip
        firstTitle="快来试试一键款式上身/爆款升级/抠图褪底"
        title="AI改款"
        placement="left"
        keyValue="aiToolTip"
        getPopupContainer={trigger => trigger}
      >
        <div
          className="aiButton"
          onClick={e => {
            e && e.stopPropagation()
            fdTrack.reportCustom('FD_Style_Detail_AiTool_Entrance_Click')
            fdAiDrawerRef.current?.setRefProductUrl(mainUrl)
          }}
        >
          <Icon type="m-aigaikuan" />
        </div>
      </FirstNormalTip>
      {
        tabValue !== IMAGE_DETAIL_TAB.ANNOTATION ? <>
          {Object.keys(userInfo)?.length > 0 ? <Tooltip title="智能搜图" placement="left"><div
            className="button"
            onClick={() => window.open(`/imageSearch?mainUrl=${currentImage.mainUrl}&originUrl=${currentImage.mainUrl}`)}
          >
            <Icon type="m-zhinengsoutu" />
          </div>
          </Tooltip> : null}
          <Tooltip placement="left" title={showNoteLabel ? '关闭批注' : '显示批注'}><div
            className="button"
            onClick={() => {
              onShowNoteLabel(!showNoteLabel)
            }}
          >
            <Icon type={!showNoteLabel ? 'm-yincang' : 'm-xianshi'} />
          </div>
          </Tooltip>
          {(!isSampleDetail && currentImage?.boxLabelRetList?.length > 0) && <Tooltip placement="left" title={showBox ? '关闭标签' : '显示标签'}><div
            className="button"
            onClick={() => {
              onShowBox(!showBox)
            }}
          >
            <Icon type={showBox ? 'm-biaoqian' : 'm-yincangbiaoqian'} />
          </div>
          </Tooltip>}
          {
            duplicateBlogNum > 1 && teamHasAuth('meinian_duplicate_images') && <Tooltip title="重复采集" placement="left">
              <div
                className="button repeated-collection-wrap"
                onClick={() => {
                  util.track('mn-repeat-collect-modal', {
                    module1: '单款查重',
                  })
                  useRepeatCollectModalApiWrap({
                    data: {
                      mainUrl,
                      collectId,
                    }
                  })
                }}
              >
                <div className="repeated-collection">{formatNumber100Add(duplicateBlogNum)}</div>
                <Icon type="m-zhongfucaiji" />
              </div>
            </Tooltip>
          }
        </> : <>
          <FirstNormalTip
            firstTitle="这里也可以新增批注"
            title="新增批注"
            placement="left"
            keyValue="mn-operation-view-annotate-tip-6"
            getPopupContainer={trigger => trigger}
          >
            <Button
              active={isAnnotate}
              type="primary"
              className={classNames('button-icon')}
              style={{ marginBottom: '8px' }}
              onClick={() => {
                setIsAnnotate(!isAnnotate)
              }}
            >
              <Icon type="m-xinzengpizhu" />
            </Button>
          </FirstNormalTip>
          <Tooltip title="适合窗口" placement="left">
            <div className="button" onClick={() => setScale(undefined)}>
              <Icon type="m-shijidaxiao" />
            </div>
          </Tooltip>
          <Tooltip title="放大图片" placement="left">
            <div className="button" onClick={() => setScale(((scale || 1) * RATIO) > MAX_SCALE ? MAX_SCALE : ((scale || 1) * RATIO))}>
              <Icon type="m-fangda" />
            </div>
          </Tooltip>
          <Tooltip title="缩小图片" placement="left">
            <div className="button" onClick={() => setScale(((scale || 1) / RATIO) < MIN_SCALE ? MIN_SCALE : ((scale || 1) / RATIO))}>
              <Icon type="m-suoxiao" />
            </div>
          </Tooltip>
        </>
      }
      {Object.keys(userInfo)?.length > 0 ? imgInfoList.length > 1 ? <Bubble
        placement="leftBottom"
        autoAdjustOverflow
        content={<div style={{ width: '120px', padding: '8px' }}>
          <div className="fill-white-bg" style={{ padding: '5px 8px', marginBottom: '4px', borderRadius: '6px', cursor: 'pointer' }} onClick={download}>下载当前图片</div>
          <div className="fill-white-bg" style={{ padding: '5px 8px', borderRadius: '6px', cursor: 'pointer' }} onClick={downloadAll}>下载全部图片</div>
        </div>}
      >
        <div className="button">
          <Icon type="m-xiazai" />
        </div>
      </Bubble>
        : <Tooltip title="下载" placement="left">
          <div className="button"><Icon type="m-xiazai" onClick={download} /></div></Tooltip> : null}
    </div>
  </div>
}
